// =============================================================================
// ui/tabs/BulkActionBar.tsx — the bar that appears when rows are selected.
// -----------------------------------------------------------------------------
// `N selected · Clear · [Merge…] · Bulk Edit… · Mark Annotated · Delete`,
// transcribed from Josh's screenshot of beta.
//
// ⚠ Mark Annotated and Delete are ONE-CLICK actions with no modal in beta —
// Delete confirms, Mark Annotated does not. Both are kept that way: they are the
// two things a trader does dozens of times a week, and a dialog on each is what
// makes people stop reviewing their trades.
//
// ⚠ `Merge…` is NOT ported. It carries its own gating (same contract and side,
// disabled with a reason when the cohort is mixed) and a `mergedFrom` field that
// nothing in this client reads. It renders disabled and says so rather than
// vanishing, because a button missing from a bar you use daily reads as a
// regression, not as a port in progress.
// =============================================================================

export interface BulkActionBarProps {
  count: number;
  busy: boolean;
  onClear: () => void;
  onBulkEdit: () => void;
  onMarkAnnotated: () => void;
  onDelete: () => void;
}

export function BulkActionBar(
  { count, busy, onClear, onBulkEdit, onMarkAnnotated, onDelete }: BulkActionBarProps,
) {
  if (!count) return null;
  return (
    <div className="bulk-action-bar" data-testid="bulk-bar" role="toolbar" aria-label="Bulk actions">
      <span className="selected-count">{count} selected</span>
      <button type="button" className="btn" onClick={onClear} disabled={busy}>Clear</button>
      <span className="grow" />
      <button
        type="button" className="btn" disabled
        title="Merging is not ported yet — it needs its own gating rules and the mergedFrom field"
      >
        Merge…
      </button>
      <button type="button" className="btn primary" onClick={onBulkEdit} disabled={busy}>
        Bulk Edit…
      </button>
      <button type="button" className="btn" onClick={onMarkAnnotated} disabled={busy}>
        Mark Annotated
      </button>
      <button type="button" className="btn danger" onClick={onDelete} disabled={busy}>
        Delete
      </button>
    </div>
  );
}
